// extracted by mini-css-extract-plugin
export var triangle = "triangle-2Qq";
export var no_header_footer = "no_header_footer-3go";